module.exports = __webpack_public_path__ + "static/16-41a4005078eb15289d12351682346057.jpg";